import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ContractBundleListService } from './contractbundlelist.service';

@Component({
    selector: 'contractbundletranslationauditpopup',
    standalone: false,
    templateUrl: './contractbundletranslationauditpopup.component.html',
    styleUrls: ['../../../../style/custom-mat-dialog.component.less']
})
export class ContractBundleTranslationAuditPopupComponent implements OnInit, OnDestroy {

    columnsToDisplay: string[] = ['Feature', 'LocalContractLine', 'CreatedByUser', 'CreatedAtUtc', 'ChangedByUser', 'ChangedAtUtc'];
    public dataSource = new MatTableDataSource<ContractBundleTranslationAudit>();
    public title: string = 'Translation Audit History';
    subscriptions: any[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { bundleId: number, bundleName: string },
        public dialogRef: MatDialogRef<ContractBundleTranslationAuditPopupComponent>, private readonly contractBundleListService: ContractBundleListService) { }

    ngOnInit(): void {
        this.title = `Translation Audit History - ${this.data.bundleName}`;
        this.contractBundleListService.getContractBundleTranslationAudit(this.data.bundleId).subscribe({
            next: (result) => {
                this.dataSource.data = Array.isArray(result) ? result : [result];
            },
            error: (error) => {
                console.error('Error fetching translation audit history:', error);
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    applyFilter($event: any) {
        this.dataSource.filter = $event.target.value.trim().toLowerCase();
    }

}
